import React from 'react';
import Servicios from '../components/Servicios';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Contacto from '../components/Contacto';

const ServiciosPage = () => {
    return (
        <div className="">
            <Header />
            <Servicios />
            <Contacto />
            <Footer />
        </div>
    );
};

export default ServiciosPage;
